import { FC } from 'react';

import styled from 'styled-components';

import { ChipChoice } from '@telialt/common-chip-choice/src';
import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';
import { SPECIAL_DISPLAY_COLORS } from '@telialt/utils/src/eshopConstants';

import { BadgeComponentProps } from '../model';
import { ColoredCircle } from './ColoredCircle';

const Circle = styled(ColoredCircle)`
    margin-right: ${getPurpurSpacing('100')};
`;

type Props = { color: string; colorName: string } & BadgeComponentProps;

export const ColorBadge: FC<Props> = ({
    onClick,
    color,
    colorName,
    checked,
    disabled,
    disabledLooking,
    dataTest,
    parentUID = '',
}) => {
    const isTransparent = color === SPECIAL_DISPLAY_COLORS.TRANSPARENT;
    const isMulticolor = color === SPECIAL_DISPLAY_COLORS.MULTICOLOR;
    const isWhiteOnWhite = SPECIAL_DISPLAY_COLORS.WHITE_ARRAY.includes(color);

    const borderColor = isWhiteOnWhite ? getPurpurColor('gray300') : getPurpurColor('functionalWhite');

    return (
        <ChipChoice
            checked={checked}
            disabled={disabled}
            unavailable={disabledLooking ? 'Išparduota' : undefined}
            onChange={onClick}
            name={'color-selection' + parentUID}
            data-test={dataTest}
        >
            <Circle
                color={color}
                pattern={(isTransparent && 'transparent') || (isMulticolor && 'multicolor') || null}
                borderColor={borderColor}
                aria-hidden={true}
            />
            {colorName}
        </ChipChoice>
    );
};
